import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/hostess/scan.svg'
import _imports_1 from '@/assets/img/hostess/mail.svg'


const _withScopeId = n => (_pushScopeId("data-v-b9c2ac98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pageContainer bg_lightGrey dashboard p-5 px-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12 col-md-6" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "col-sm-12 col-md-6" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "square bg_grey",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/welcome-kit-scan')))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_localized_text, {
              localizedKey: "app_ScanForWelcomeKit",
              text: "Scan for Welcome Kit",
              class: "white fs_27 text-uppercase"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "square bg_grey",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/welcome-kit-by-email')))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_localized_text, {
              localizedKey: "app_CheckEmailForWelcomeKit",
              text: "Check email for Welcome Kit",
              class: "white fs_27 text-uppercase"
            })
          ])
        ])
      ])
    ])
  ]))
}